const GiftCredits = require("./containers/GiftCredits");
const AuthenticateAdmin = require("../utils").authenticateAdmin;

// Sync route definition
module.exports = {
    path: "/admin/giftcredits",
    component: AuthenticateAdmin(GiftCredits),
    exact: true
};



// WEBPACK FOOTER //
// ./src/routes/admin-gift-credits/index.js